import { useEffect } from 'react';
import { hasAuthParams, useAuth } from 'react-oidc-context';
import { useParams } from 'react-router-dom';

import { AppLoader } from '@ingrid/luterkort-react';

import { CONFIG } from '~src/config/config';
import { AppFetchConfig } from '~src/main/config';

/**
 * Lookup map that turns customer (path) into a connection.
 */
const Connection: Record<string, string> = {
  default: 'Username-Password-Authentication',
  apoteket: CONFIG.AUTH0_APOTEKET_CONNECTION,
};

export function AppLoginPage() {
  const { customer } = useParams();
  const auth = useAuth();

  /**
   * @external: https://github.com/authts/react-oidc-context/blob/main/src/withAuthenticationRequired.tsx
   */
  useEffect(() => {
    if (hasAuthParams() || auth.isLoading || auth.activeNavigator || auth.isAuthenticated) {
      return;
    }

    void (async () => {
      await auth.signinRedirect({
        extraQueryParams: {
          connection: Connection[customer ?? 'default'],
          audience: `${AppFetchConfig.apiUrl}/`,
        },
      });
    })();
  }, [auth, customer]);

  return <AppLoader />;
}
